:host {
    display: block;
    background-color: rgba(0, 0, 0, 0.6);
    position: relative;
    transition: opacity linear 300ms;

    sew-ws-menu-link[type='return'] {
        position: absolute;
        top: 22px;
        left: 28px;
        z-index: 101;
    }

    .nav-grid {
        @include grid;
    }

    .nav-container {
        grid-column: 2 / -2;
        position: relative;
        overflow: hidden;
        height: max(calc(100vh - var(--header-height)), calc(100vh - var(--header-height-scrolled)));

        &::after {
            content: '';
            height: 4px;
            width: 100%;
            top: 0;
            right: 0;
            background-color: $color-white;
            position: absolute;
            transform-origin: right;
            animation: lineAnimation linear 0.3s forwards;
        }
    }

    .nav-columns {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        transition: transform 0.3s;
    }

    .nav-column {
        position: relative;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 25%;
        min-width: 25%;
        padding: 60px 40px 0 60px;
        background-color: $color-white;
        animation: fade linear 0.3s forwards;

        &:first-of-type {
            padding: 60px 40px 0 80px;
        }

        &:not(:last-child)::before {
            content: '';
            position: absolute;
            top: 61px;
            bottom: 61px;
            right: 0;
            width: 1px;
            border-left: 1px solid $color-palette-iron050;
        }

        &:nth-child(n + 5) {
            animation: 0;
        }
    }

    .panel-container {
        display: grid;
        grid-template-rows: auto 1fr 20px;
        row-gap: 20px;
        height: 100%;
        overflow-y: scroll;

        sew-ws-menu-link {
            text-wrap: balance;
        }
    }

    .panel-list {
        grid-row: 2;
        display: flex;
        gap: 20px;
        flex-direction: column;
        overflow-y: scroll;
        scroll-snap-type: y mandatory;

        sew-ws-menu-link {
            scroll-snap-align: end;

            &:last-of-type {
                padding-bottom: 40px;
            }
        }
    }

    .panel-list,
    .panel-container {
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .scroll-btn {
        cursor: pointer;
        position: absolute;
        background-color: transparent;
        border: 0;
        color: $color-grey-01-dark;
        align-self: center;
        z-index: 1;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;

        .svg {
            width: 48px;
            margin: -17px 0;
        }

        &--up {
            top: 40px;
        }

        &--down {
            bottom: 20px;

            &::after {
                position: absolute;
                content: '';
                bottom: 100%;
                left: 0;
                width: calc(100% - 5px);
                height: 130px;
                background: linear-gradient(to bottom, transparent, $color-white);
                pointer-events: none;
            }
        }
    }
}

.close-btn {
    all: unset;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    color: $color-grey-01-dark;
}

:host([has-main-navigation]) {
    .nav-container {
        &::after {
            display: none;
        }
    }
}

:host(.close-animation) {
    opacity: 0;

    .nav-columns {
        transform: translate3d(-100%, 0, 0) !important;
    }

    .nav-container {
        &::after {
            animation: lineAnimationClose linear 0.3s forwards;
        }
    }
}

@include mq-3 {
    :host {
        .nav-container {
            grid-column: 1 / -1;
        }

        .nav-column {
            padding: 60px 50px 0 60px;

            &:first-of-type {
                padding: 60px 32px 0 80px;
            }
        }
    }
}

@include mq-2-5 {
    :host {
        .nav-column {
            padding: 60px 20px 0 40px;
            width: 33.33%;
            min-width: 33.33%;

            &:nth-child(n + 4) {
                animation: 0;
            }
        }
    }
}

@include mq-2 {
    :host {
        .nav-column {
            padding: 60px 20px 0 40px;
            width: 50%;
            min-width: 50%;

            &:nth-child(n + 3) {
                animation: 0;
            }

            &:first-of-type {
                padding: 60px 20px 0 40px;
            }
        }
    }
}

@include mq-1 {
    :host {
        .nav-column {
            width: 100%;
            min-width: 100%;
            padding: 60px 40px 0;

            &:first-of-type {
                padding: 60px 40px 0;
            }

            &:not(:first-of-type) {
                animation: unset;
            }

            &:not(:last-child)::before {
                display: none;
            }
        }
    }
}

@keyframes fade {
    from {
        transform: translate3d(calc(var(--nav-column-width) * -1), 0, 0);
        opacity: 0;
    }

    to {
        transform: translate3d(0);
        opacity: 1;
    }
}

@keyframes lineAnimation {
    from {
        transform: scale3d(0, 1, 1);
    }

    to {
        transform: scale3d(1, 1, 1);
    }
}

@keyframes lineAnimationClose {
    from {
        transform: scale3d(1, 1, 1);
    }

    to {
        transform: scale3d(0, 1, 1);
    }
}
